import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../api";

export const updatePreviewFunction = createAsyncThunk(
  "preview/updatePreviewFunction",
  async ({status, construction_preview_id , cancel_reason } , { rejectWithValue }) => {
    try {
      const response = await PrivateAxios.post(
        `/api/user/construction/updateOrder`,
        { status , construction_preview_id , cancel_reason },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.data.status) {
        return rejectWithValue(response.data.message || "Invalid status.");
      }

      return response.data.data;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      return rejectWithValue(
        error.response?.data || error.request || "Failed to fetch orders"
      );
    }
  }
);

const initialState = {
  updatePreview: null,
  status: "idle",
  error: null,
};

const previewsUpdateSlice = createSlice({
  name: "updatePreview",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePreviewFunction.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updatePreviewFunction.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.updatePreview = action.payload;
      })
      .addCase(updatePreviewFunction.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export default previewsUpdateSlice.reducer;